<template>
  <div>
    <div class="breadcrumb">
      <v-breadcrumb>
        <!-- <v-breadcrumb-item>
          <v-icon type="home"></v-icon>
          <a @click="() => $router.push('/student/dashboard')">Dashboard </a>
        </v-breadcrumb-item> -->
        <v-breadcrumb-item>
          <v-icon type="global"></v-icon>
          <a @click="() => $router.go(-1)">Schools </a>
        </v-breadcrumb-item>
        <v-breadcrumb-item v-if="school">
          <span>{{school.name}}</span>
        </v-breadcrumb-item>
      </v-breadcrumb>
    </div>
    <div v-if="school" class="main-details">
      <div class="school-header">
        <h2>
          <div class="img-wrap">
            <img :src="`http://storage.googleapis.com/caned-dev.appspot.com/college-logos/${school.name.toLowerCase()}.png`" width="30px" />
          </div>
          <div>
            <h4>{{school.name}}, {{school.campus}}</h4>
            <h5>{{school.province}}</h5>
          </div>
        </h2>
      </div>

      <ProgramsFilterSchool :filterSchoolTopPrograms="filterSchoolTopPrograms" :setFilters="setFilters" />

      <div>
        <div class="programs-view">
          <div v-for="program of programs" :key="program.id" class="program" v-if="programs">
            <v-card :title="program.name">

              <div class="prog-details">
                <div class="details">
                  <div class="details-row">
                    <div>
                      <p><b><v-icon type="clock-circle-o"></v-icon>&nbsp;Duration:</b>
                      &emsp;{{program.duration}}</p>
                    </div>
                    <div>
                      <p><b><v-icon type="file"></v-icon>&nbsp;Application Fee:</b>
                      &emsp;{{program.application_fee}}</p>
                    </div>
                    <div>
                      <p><b><v-icon type="book"></v-icon>&nbsp;Tution Fee:</b>
                      &emsp;{{program.tution_fee}}</p>
                    </div>
                  </div>

                  <div class="details-row">
                    <div style="display:flex;justify-content:flex-start;margin-top:8px;">
                      <ToggleSwitch :model="program.september" label="September Intake:" size="small" />
                      <ToggleSwitch :model="program.january" label="January Intake:" size="small" />
                      <ToggleSwitch :model="program.may" label="May Intake:" size="small" />
                    </div>
                  </div>

                  <div v-if="progDetailsView.includes(program.id)" style="margin-top: 8px;">
                    <div class="details-row">
                      <div>
                        <p><b><v-icon type="book"></v-icon>&nbsp;Area of study:</b>
                        &emsp;{{program.area_of_study}}</p>
                      </div>
                      <div>
                        <p><b><v-icon type="book"></v-icon>&nbsp;Level of study:</b>
                        &emsp;{{program.level_of_study}}</p>
                      </div>
                      <div>
                        <p><b><v-icon type="check-square-o"></v-icon>&nbsp;Test Score Required:</b>
                        &emsp;{{program.ielts}}</p>
                      </div>
                    </div>
                    <div @click="() => progDetailsView.pop(program.id)" class="view-less">View Concise..</div>
                  </div>
                  <div v-if="!progDetailsView.includes(program.id)">
                    <span @click="() => progDetailsView.push(program.id)" class="view-more">View Details..</span>
                  </div>
                </div>

                <div class="action">
                  <v-button type="primary" @click="() => showSelectStudent(program)">
                    Apply
                  </v-button>
                </div>
              </div>

            </v-card>
          </div>
        </div>
      </div>

      <div class="view-select-wrap" v-if="programs.length">
        <span @click="() => viewMorePrograms()" v-if="!fullProgramsView" class="view-more">View more programs..</span>
        <span @click="() => viewLessPrograms()" v-if="fullProgramsView" class="view-less">View less programs..</span>
      </div>

    </div>

    <v-modal title="Select Student" :visible="selectStudentVisible" @cancel="cancelSelectStudent" v-if="students">
      <div class="students-wrap">
        <v-select placeholder="Select Student" size="medium" :data="optionsStudents" v-model="selectedStudent"
          @change="selectStudent" style="width:100%"></v-select>

        <div class="student-details" v-if="selectedStudent">
          <div>
            <p><b><v-icon type="user"></v-icon>&nbsp;Full Name:</b>
            &emsp;{{studentDetails[selectedStudent].personal_details.first_name}} {{studentDetails[selectedStudent].personal_details.last_name}}</p>
          </div>
          <div>
            <p><b><v-icon type="mobile"></v-icon>&nbsp;Phone Number:</b>
            &emsp;{{studentDetails[selectedStudent].personal_details.phone_number}}</p>
          </div>
          <div>
            <p><b><v-icon type="environment-o"></v-icon>&nbsp;Address:</b>
            &emsp;{{studentDetails[selectedStudent].personal_details.address}}</p>
          </div>
        </div>
      </div>

      <div slot="footer">
        <v-button key="cancel" type="ghost" size="large" @click="cancelSelectStudent">Cancel</v-button>
        <v-button key="confirm" type="primary" size="large" @click="applyProgram">Apply</v-button>
      </div>
    </v-modal>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import fb from '@/firebase'
import ProgramsFilterSchool from '../../components/ProgramsFilterSchool'

export default {
  name: 'AdminSchoolWebView',
  data () {
    return {
      selectStudentVisible: false,
      selectedProgram: null,
      appliedPrograms: {},
      programs: [],
      fullProgramsView: false,
      filters: [],
      progDetailsView: [],
      optionsStudents: [],
      studentDetails: {},
      selectedStudent: null
    }
  },
  created () {
    this.$store.dispatch('getSchool', this.$route.params.id)
  },
  computed: {
    ...mapGetters([
      'user',
      'school',
      'schoolTopPrograms',
      'schoolPrograms',
      'canEdStudents'
    ])
  },
  watch: {
    school: {
      handler (val) {
        if (val && val.id === this.$route.params.id) {
          this.$store.dispatch('getSchoolTopPrograms', val.ref)
          this.$store.dispatch('getUserApplications', val.ref)
        }
      },
      immediate: true
    },
    schoolPrograms: {
      handler (val) {
        if (val) {
          this.programs = val
        }
      }
    },
    schoolTopPrograms: {
      handler (val) {
        if (val) {
          this.programs = val
        }
      }
    },
    canEdStudents: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getCanEdStudents')
        } else {
          val.forEach(item => {
            if (item.personal_details) {
              this.optionsStudents.push({
                label: item.personal_details.email,
                value: item.id
              })
            }
            this.studentDetails[item.id] = item
          })
        }
      },
      immediate: true
    },
  },
  methods: {
    userAction (data) {
      if (data.content === 'Logout') {
        fb.logout()
        this.$router.push('/auth')
      }
    },
    applyProgram () {
      const student = this.studentDetails[this.selectedStudent]

      if (student.personal_details && student.academic_details &&
        student.english_language_ability && student.documents_uploaded) {

        this.selectedProgram.status = 'Applied'
        this.selectedProgram.userRef = student.ref
        this.selectedProgram.prog_id = this.selectedProgram.id
        this.selectedProgram.prog_ref = this.selectedProgram.ref
        this.selectedProgram.visa_status = null
        this.selectedProgram.source = 'WebApp'
        this.$store.dispatch('addApplication', this.selectedProgram)
        this.cancelSelectStudent()
      } else {
        this.$modal.confirm({
          title: 'Student profile is not updated to apply for program',
          // content: 'Proceed with updating profile ?',
          cancelText: 'cancel',
          okText: 'ok',
          onOk: async () => {
            this.cancelSelectStudent()
            return new Promise(function (resolve) {
              setTimeout(resolve, 500)
            })
          },
          onCancel: function () {
            this.cancelSelectStudent()
            return new Promise(function (resolve) {
              setTimeout(resolve, 500)
            })
          }
        })
      }
    },
    viewLessPrograms () {
      this.fullProgramsView = false
      this.getPrograms()
    },
    viewMorePrograms () {
      this.fullProgramsView = true
      this.getPrograms()
    },
    filterSchoolTopPrograms (filters) {
      this.filters = [...filters]
      this.getPrograms()
    },
    setFilters (filters) {
      this.filters = [...filters]
    },
    getPrograms () {
      this.programs = []
      if (this.filters.length) {
        if (this.fullProgramsView) {
          this.$store.dispatch('getSchoolProgramsFiltered',
            {schoolRef: this.school.ref, filters: this.filters})
        } else {
          this.$store.dispatch('getSchoolTopProgramsFiltered',
            {schoolRef: this.school.ref, filters: this.filters})
        }
      } else {
        if (this.fullProgramsView) {
          this.$store.dispatch('getSchoolPrograms', this.school.ref)
        } else {
          this.$store.dispatch('getSchoolTopPrograms', this.school.ref)
        }
      }
    },
    cancelSelectStudent () {
      this.selectStudentVisible = false
      this.selectedProgram = null
      this.selectedStudent = null
    },
    showSelectStudent (program) {
      this.selectStudentVisible = true
      this.selectedProgram = program
    },
    selectStudent (id) {

    }
  },
  components: {
    ProgramsFilterSchool
  }
}
</script>

<style scoped>
.breadcrumb {
  padding: 16px;
}
.main-details {
  padding: 0 16px 16px;
}
.programs-view {
  margin-top: 8px;
}
.programs-view .program {
  margin-bottom: 12px;
}
.prog-details {
  display: flex;
  justify-content: space-between;
}
.prog-details .action {
  width: 15%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.prog-details .details {
  width: 85%;
}
.prog-details .details .details-row {
  display: flex;
  justify-content: space-between;
}
.school-header {
  margin-bottom: 20px;
}
.school-header h2 {
  display: flex;
  align-items: center;
}
.school-header h2 .img-wrap {
  width: 125px;
  height: 70px;
  overflow: hidden;
}
.school-header h2 img {
  width: 120px;
}
.view-select-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4px 0 2px;
}
.view-more {
  cursor: pointer;
  color: #00a854;
}
.view-less {
  cursor: pointer;
  color: #ffbf00;
}
.student-details {
  margin-top: 12px;
}
.ant-card-head {
  height: 36px;
  line-height: 36px;
  background-color: #404040;
  padding: 0 10px;
}
.ant-card-head-title {
  font-size: 13px;
  color: ivory;
}
.ant-card-body {
  padding: 10px;
}
.ant-collapse-header {
  color: #404040;
  font-size: 13px;
  font-weight: bold;
}
.ant-breadcrumb-link a, .ant-breadcrumb-link i {
  color: #108ee9;
  text-decoration: none;
}
.ant-switch {
  border-color: #eaeaea;
}
.ant-switch-inner .anticon {
  color: #f04134;
}
.ant-switch-checked .ant-switch-inner .anticon {
  color: #00a854;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/AdminSchoolWebView.vue